export const categories = [
  {
    slug: 'quanxin',
    name: '全新番号',
    description: '最新发布的番号作品，第一时间获取更新信息',
    icon: 'ri-sparkling-line',
    count: 2847,
    color: 'primary',
  },
  {
    slug: 'remen',
    name: '热门番号',
    description: '当前最受欢迎和搜索量最高的番号',
    icon: 'ri-fire-line',
    count: 1623,
    color: 'accent',
  },
  {
    slug: 'jingdian',
    name: '经典番号',
    description: '经久不衰、口碑极佳的经典番号合集',
    icon: 'ri-star-line',
    count: 951,
    color: 'secondary',
  },
  {
    slug: 'heji',
    name: '合集系列',
    description: '番号系列合集，方便系统浏览和收藏',
    icon: 'ri-stack-line',
    count: 438,
    color: 'primary',
  },
  {
    slug: 'danpian',
    name: '单片推荐',
    description: '精选优质单片番号，每部都值得收藏',
    icon: 'ri-movie-line',
    count: 2156,
    color: 'accent',
  },
  {
    slug: 'gaoqing',
    name: '高清资源',
    description: '高清画质番号资源，极致视觉体验',
    icon: 'ri-4k-line',
    count: 1872,
    color: 'secondary',
  },
  {
    slug: 'xinren',
    name: '新人作品',
    description: '新晋编号作品，发现更多精彩内容',
    icon: 'ri-user-add-line',
    count: 563,
    color: 'primary',
  },
  {
    slug: 'zhuanji',
    name: '专题策划',
    description: '按主题精心策划的番号专题合集',
    icon: 'ri-bookmark-line',
    count: 326,
    color: 'accent',
  },
];

export const featuredCategories = [
  { slug: 'quanxin', name: '全新番号' },
  { slug: 'remen', name: '热门番号' },
  { slug: 'jingdian', name: '经典番号' },
  { slug: 'danpian', name: '单片推荐' },
];